import { signInAppBehaviorIds } from '@famly/vet_signin-app-behavior-ids';
/** The site has the kiosk's redesigned screens, for parents with a PIN, in rooms and for staff */
export const hasSignInRedesign = (state) => state.institutionOverview.features.includes(signInAppBehaviorIds.redesign);
